<template>
  <div class="shop">
    <van-nav-bar title="问" :border='false'>        
      <img slot="left" class="navbarmem" @click="goMy(0)" :src="user && user.avatar ? user.avatar : img.avatar">
      <img slot="title" class="navbartitle" :src="img.navshop">
      <img slot="right" class="navbarwrite" :src="img.topclass">
    </van-nav-bar>
    <van-grid :column-num="3" :border='false'>
      <van-grid-item :icon="img.presell" text="预售" />
      <van-grid-item :icon="img.group" text="团购" />
      <van-grid-item :icon="img.second" text="秒杀" />
      <van-grid-item :icon="img.minus" text="满减" />
      <van-grid-item :icon="img.turn" text="转让" />
      <van-grid-item :icon="img.integral" text="积分" />
    </van-grid>
    <div class="column">
      <img class="columnpic" :src="img.kings">
      <div class="f-17 f-w mt-8">热销商品</div>
      <div class="f-12 f-w mt-8">Hot-selling commodities</div>
      <div class="expect">即将上线，敬请期待</div>
    </div>
    <div class="column">
      <img class="columnpic" :src="img.diaminds">
      <div class="f-17 f-w mt-8">品牌商品</div>
      <div class="f-12 f-w mt-8">Brand goods</div>
      <div class="expect">即将上线，敬请期待</div>
    </div>
    <div class="column">
      <img class="columnpic" :src="img.wheel">
      <div class="f-17 f-w mt-8">汽车周边</div>
      <div class="f-12 f-w mt-8">Car perimeter</div>
      <div class="expect">即将上线，敬请期待</div>
    </div>
    <div class="column">
      <img class="columnpic" :src="img.star">
      <div class="f-17 f-w mt-8">线下活动</div>
      <div class="f-12 f-w mt-8">Offline activities</div>
      <div class="expect">即将上线，敬请期待</div>
    </div>
  </div>
</template>
<script>
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Grid, GridItem,NavBar } from 'vant';
  export default {
    data () {
      return {
        top_margin: 0,
        img:{
          navshop: require('../../../assets/img/lexus/navshop.png'),
          topclass: require('../../../assets/img/lexus/shop/class.png'),
          presell: require('../../../assets/img/lexus/shop/presell.png'),
          group: require('../../../assets/img/lexus/shop/group.png'),
          second: require('../../../assets/img/lexus/shop/second.png'),
          minus: require('../../../assets/img/lexus/shop/minus.png'),
          turn: require('../../../assets/img/lexus/shop/turn.png'),
          integral: require('../../../assets/img/lexus/shop/integral.png'),
          kings: require('../../../assets/img/lexus/shop/kings.png'),
          diaminds: require('../../../assets/img/lexus/shop/diaminds.png'),
          wheel: require('../../../assets/img/lexus/shop/wheel.png'),
          star: require('../../../assets/img/lexus/shop/star.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      var params={
        event_code: '商城',
        event_id:'',
        title: '',
        value: '',
        path: '/Lexus/Shop/Index.vue',
        user_id: this.user_id ? this.user_id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
    },
    activated () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: false})
      this.$appService.getWinHeight(v => {
        console.log('getWinHeight=='+v.height)
        this.top_margin = 0
      })
      this.$appService.isTabbar({state: false})
    },
    methods: {

    },
    components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [NavBar.name]:NavBar
    }
  }
</script>
<style lang="scss">
.shop{
  margin-top: 45px;
  background-color: #F0F0F0;
  .van-nav-bar{
    z-index: 999;
    position: fixed;
    top: 0;
    width: 100%;
    .van-nav-bar__left{
      top: 10px;
      .navbarmem{
        width: 30px;
      }
    }
    .van-nav-bar__title{
      .navbartitle{
        margin-top: 10px;
        width: 30px;
        height: 27px;
      }
    }
    .van-nav-bar__right{
      top: 5px;
      .navbarwrite{
        width: 20px;
      }
    }
  }
  .van-grid-item__text{
    font-size: 13px;
    color: #9A9A9A;
  }
  .van-icon__image{
    width: 20px;
    height: 20px;
  }
  .column{
    width: 100%;
    height: 365px;
    background-color: #fff;
    margin: 10px 0;
    text-align: center;
    .columnpic{
      width: 22px;
      height: 20px;
      margin-top: 50px;
    }
    .mt-8{
      margin-top: 8px;
    }
    .expect{
      font-size: 13px;
      color: #9A9A9A;
      margin-top: 118px;
    }
  }
}
</style>
